(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  // Dismissal only — the scroll itself is CSS.
  (function announcementBar() {
    const KEY = 'ye:announcement-dismissed';

    document.querySelectorAll('[data-announcement]').forEach((bar) => {
      let dismissed = false;
      try {
        dismissed = localStorage.getItem(KEY) === '1';
      } catch (error) {
        // Private mode or blocked storage: just show the bar.
      }

      if (dismissed) {
        bar.hidden = true;
        return;
      }

      const close = bar.querySelector('[data-announcement-close]');
      if (!close) return;

      close.addEventListener('click', () => {
        bar.hidden = true;
        try {
          localStorage.setItem(KEY, '1');
        } catch (error) {
          // Dismissal just won't persist.
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  // The drawer re-renders through the Section Rendering API, so every listener
  // is delegated from the document — nothing is bound to markup that gets
  // replaced. The JS never constructs a line item; Liquid stays authoritative.
  class CartDrawer {
    static get root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    // Section id used both for ?section_id= renders and for the `sections`
    // parameter the cart API accepts.
    static section = 'cart-drawer';

    // A variant swap is a remove-and-add, so Shopify moves that line to the
    // end of the cart. The drawer remembers the order the shopper last saw
    // and restores it, so a row never jumps position under their finger.
    static orderKey = 'ye-cart-order';

    static get order() {
      try {
        const raw = sessionStorage.getItem(CartDrawer.orderKey);
        const list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list.map(String) : [];
      } catch (error) {
        return [];
      }
    }

    static set order(list) {
      try {
        sessionStorage.setItem(CartDrawer.orderKey, JSON.stringify(list));
      } catch (error) {
        // Private browsing and the like — ordering just falls back to Shopify's.
      }
    }

    // Rows are moved as groups: anything that is not a cart line (the pin
    // upsell) travels with the line it was rendered under.
    static applyOrder() {
      const el = CartDrawer.el;
      const list = el && el.querySelector('.drawer__items');
      if (!list) return;

      const groups = new Map();
      let current = null;
      let hero = null;

      [...list.children].forEach((node) => {
        const id = node.dataset.itemVariant;
        const role = node.dataset.itemRole;

        // The add-on is not a group of its own — it belongs to the bag, so it
        // cannot be moved away from it by a remembered order.
        if (id && role === 'addon' && hero) {
          hero.nodes.push(node);
          return;
        }

        if (id) {
          current = { id, nodes: [node] };
          groups.set(id, current);
          if (role === 'hero') hero = current;
          return;
        }

        if (current) current.nodes.push(node);
      });

      const ordered = CartDrawer.order.filter((id) => groups.has(id));
      groups.forEach((group, id) => {
        if (!ordered.includes(id)) ordered.push(id);
      });

      ordered.forEach((id) => {
        groups.get(id).nodes.forEach((node) => list.appendChild(node));
      });

      CartDrawer.order = ordered;
    }

    static get el() {
      return document.querySelector('[data-cart-drawer]');
    }

    static open() {
      const el = CartDrawer.el;
      CartDrawer.applyOrder();
      if (!el) return;

      // Mobile PDP only: the sticky add-to-cart bar (and the nav above
      // it) need to stay visible in front of the drawer, undimmed —
      // impossible with showModal()'s top layer, which nothing else can
      // ever render above no matter its z-index. That one context opens
      // non-modally instead; every other page keeps the native modal,
      // exactly as before. The old no-showModal-support fallback folds
      // into the same branch — it never had a real backdrop either, so
      // gaining the scrim here is a bonus for it, not a behavior change.
      const stickyBar = document.querySelector('[data-v2-sticky]');
      const nav = document.querySelector('.nav');
      const wantsNonModal = !!stickyBar && window.innerWidth <= 699;
      const scrim = document.querySelector('[data-drawer-scrim]');

      if (wantsNonModal && nav) {
        const navBottom = Math.max(0, nav.getBoundingClientRect().bottom);
        document.documentElement.style.setProperty('--drawer-nav-clear', `${navBottom}px`);
      }

      if (!wantsNonModal && typeof el.showModal === 'function') {
        if (!el.open) el.showModal();
        if (scrim) scrim.hidden = true;
      } else if (typeof el.show === 'function') {
        if (!el.open) el.show();
        if (scrim) scrim.hidden = false;
      } else {
        el.setAttribute('open', '');
        if (scrim) scrim.hidden = false;
      }

      // <dialog> autofocuses the first focusable descendant, which is the
      // close button — that reads as an accidental highlight rather than
      // useful focus. Focus the dialog itself instead.
      if (typeof el.focus === 'function') el.focus();
    }

    static close() {
      const el = CartDrawer.el;
      if (!el) return;
      if (typeof el.close === 'function') el.close();
      else el.removeAttribute('open');

      const scrim = document.querySelector('[data-drawer-scrim]');
      if (scrim) scrim.hidden = true;
    }

    static busy(state) {
      const el = CartDrawer.el;
      if (el) el.classList.toggle('is-busy', state);
    }

    // Pull fresh markup for just this section and swap the inner contents,
    // keeping the <dialog> itself so an open drawer stays open.
    static async refresh() {
      const el = CartDrawer.el;
      if (!el) return;

      const response = await fetch(`${CartDrawer.root}?section_id=cart-drawer`);
      if (!response.ok) return;

      CartDrawer.paint(await response.text());
    }

    // Every cart write asks Shopify to return this section's markup in the
    // same response (`sections` on the cart API), so a change costs one round
    // trip instead of a write followed by a separate render fetch.
    static paint(markup) {
      const el = CartDrawer.el;
      if (!el || !markup) return false;

      const fresh = new DOMParser()
        .parseFromString(markup, 'text/html')
        .querySelector('[data-cart-drawer]');
      if (!fresh) return false;

      el.innerHTML = fresh.innerHTML;
      el.dataset.cartCount = fresh.dataset.cartCount || '0';
      CartDrawer.applyOrder();
      CartDrawer.paintCount(Number(el.dataset.cartCount));
      CartDrawer.syncPdpButtons(el);
      return true;
    }

    // A PDP "Add to cart" button reads "View cart" once its add succeeds
    // (see the submit handler below). That variant can leave the cart from
    // here — removed, or its qty dropped to 0 — without the PDP form itself
    // ever firing a change event, so the button was stuck reading "View
    // cart" for an item no longer in the cart. Runs on every repaint and
    // reverts any such button whose variant isn't in the fresh cart.
    static syncPdpButtons(freshDrawer) {
      const buttons = document.querySelectorAll('[data-v2-add][data-v2-added="true"]');
      if (!buttons.length) return;

      const inCart = new Set(
        [...freshDrawer.querySelectorAll('[data-item-variant]')].map((el) => el.dataset.itemVariant)
      );

      buttons.forEach((button) => {
        const form = button.closest('form');
        const field = form && form.querySelector('[name="id"]:checked, input[type="hidden"][name="id"]');
        const variantId = field && field.value;
        if (variantId && inCart.has(variantId)) return;

        button.dataset.v2Added = 'false';
        button.classList.remove('v2__submit--added');
        const label = button.querySelector('[data-v2-add-label]');
        if (label && button.dataset.addLabel) label.textContent = button.dataset.addLabel;
      });
    }

    // Writes to the cart and repaints from the bundled section markup,
    // falling back to a separate render fetch if it is missing.
    static async write(path, body) {
      let data = null;

      try {
        const response = await fetch(`${CartDrawer.root}${path}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ ...body, sections: CartDrawer.section }),
        });
        data = await response.json();
      } catch (error) {
        data = null;
      }

      const markup = data && data.sections && data.sections[CartDrawer.section];
      if (CartDrawer.paint(markup)) return true;

      await CartDrawer.refresh();
      return data != null;
    }

    static paintCount(count) {
      document.querySelectorAll('[data-cart-count-target]').forEach((node) => {
        node.textContent = String(count);
        node.hidden = count < 1;
      });
    }

    static async post(path, body) {
      CartDrawer.busy(true);
      try {
        return await CartDrawer.write(path, body);
      } finally {
        CartDrawer.busy(false);
      }
    }

    static init() {
      // async: the add-on branch awaits a cart write.
      document.addEventListener('click', async (event) => {
        const opener = event.target.closest('[data-cart-open]');
        if (opener) {
          event.preventDefault();
          // Toggle: clicking the cart icon while it's already open should
          // close it, not no-op (CartDrawer.open() only opens, it never
          // closed anything).
          if (CartDrawer.el && CartDrawer.el.open) {
            CartDrawer.close();
          } else {
            CartDrawer.open();
          }
          return;
        }

        if (event.target.closest('[data-cart-close]')) {
          CartDrawer.close();
          return;
        }

        const upsell = event.target.closest('[data-drawer-addon]');
        if (upsell) {
          event.preventDefault();

          const id = Number(upsell.dataset.drawerAddon);
          if (!id) return;

          upsell.disabled = true;
          await CartDrawer.post('cart/add.js', { items: [{ id, quantity: 1 }] });
          return;
        }

        const line = event.target.closest('[data-line-change]');
        if (line) {
          event.preventDefault();
          CartDrawer.post('cart/change.js', {
            line: Number(line.dataset.lineChange),
            quantity: Number(line.dataset.lineQty),
          });
        }
      });

      // Clicking the backdrop closes; <dialog> reports those clicks on itself.
      document.addEventListener('click', (event) => {
        const el = CartDrawer.el;
        if (!el || event.target !== el) return;
        CartDrawer.close();
      });

      // Same, for the non-modal path's own scrim (see CartDrawer.open()) —
      // a real element, not a pseudo-element, so a plain click works.
      const drawerScrim = document.querySelector('[data-drawer-scrim]');
      if (drawerScrim) {
        drawerScrim.addEventListener('click', () => CartDrawer.close());
      }

      // Quick add on product cards: adds the card's own variant directly and
      // opens the cart, same as any other add-to-cart — no variant picker.
      document.addEventListener('click', async (event) => {
        const submit = event.target.closest('[data-quick-submit]');
        if (!submit) return;

        const variantId = Number(submit.dataset.quickVariantId);
        if (!variantId) return;

        submit.disabled = true;
        await CartDrawer.post('cart/add.js', {
          items: [{ id: variantId, quantity: 1 }],
        });
        CartDrawer.open();
        submit.disabled = false;
      });

      // Changing a line's variant. The cart API has no swap, but one
      // /cart/update.js can zero the old line and add the new variant at
      // once — keyed by line key so a shared variant elsewhere in the cart
      // is untouched. The chip is repainted immediately so the choice reads
      // as instant while the request is in flight.
      document.addEventListener('click', async (event) => {
        const picker = event.target.closest('[data-line-variant]');
        if (!picker) return;
        if (picker.getAttribute('aria-pressed') === 'true') return;

        const key = picker.dataset.lineKey;
        const quantity = Number(picker.dataset.lineQuantity) || 1;
        const id = Number(picker.dataset.variantId);
        if (!key || !id) return;

        const group = picker.closest('.drawer__item-options');
        if (group) {
          group
            .querySelectorAll('[data-line-variant]')
            .forEach((chip) => chip.setAttribute('aria-pressed', String(chip === picker)));
        }

        // Record what is on screen, then hand this row's slot to the new
        // variant so the repaint puts it back where it already was.
        CartDrawer.applyOrder();
        const row = picker.closest('.drawer__item');
        const previous = row && row.dataset.itemVariant;
        if (previous) {
          CartDrawer.order = CartDrawer.order.map((entry) =>
            entry === String(previous) ? String(id) : entry
          );
        }

        CartDrawer.busy(true);
        try {
          await CartDrawer.write('cart/update.js', {
            updates: { [key]: 0, [id]: quantity },
          });
        } finally {
          CartDrawer.busy(false);
        }
      });

      document.addEventListener('submit', async (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (!form.action || !form.action.includes('/cart/add')) return;

        event.preventDefault();
        CartDrawer.busy(true);

        // A ticked add-on turns this into a two-line-item request. Variant ids
        // and prices still come from Liquid; only the shape of the post changes.
        const addon = form.querySelector('[data-addon-variant]:checked');
        const data = new FormData(form);

        // Both shapes ask for the drawer markup back with the add, so the
        // drawer opens on one round trip instead of two.
        data.append('sections', CartDrawer.section);

        const payload = addon
          ? {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [
                  { id: Number(data.get('id')), quantity: Number(data.get('quantity')) || 1 },
                  { id: Number(addon.dataset.addonVariant), quantity: 1 },
                ],
                sections: CartDrawer.section,
              }),
            }
          : { method: 'POST', headers: { Accept: 'application/json' }, body: data };

        try {
          const response = await fetch(`${CartDrawer.root}cart/add.js`, payload);

          if (!response.ok) {
            // Fall back to a normal navigation so the customer still gets
            // feedback rather than a silently dead button.
            form.submit();
            return;
          }

          let result = null;
          try {
            result = await response.json();
          } catch (error) {
            result = null;
          }

          const markup = result && result.sections && result.sections[CartDrawer.section];
          if (!CartDrawer.paint(markup)) await CartDrawer.refresh();

          CartDrawer.open();

          // Disabled (2026-09-15) — the PDP's add-to-cart button no longer
          // swaps to "View cart" after a successful add; it was intended
          // as confirmation, but the request now is for it to always stay
          // "Add to cart". The swap's own added-state styling
          // (.v2__submit--added, a white background with a yellow ring)
          // was designed around the original all-yellow button and had
          // started looking like a stray yellow outline on the black
          // buttons non-Banackpack products now use. Leaving the whole
          // mechanism intact and just not calling it: resetAddedOnChange()
          // in product-detail-v2.liquid and syncPdpButtons() below both
          // still work fine, they just never have anything to reset now
          // that nothing sets v2Added to begin with. Revert by restoring
          // the four lines below.
          // const submitter = event.submitter;
          // const pdpButton = (submitter && submitter.closest('[data-v2-add]')) || form.querySelector('[data-v2-add]');
          // if (pdpButton) {
          //   const label = pdpButton.querySelector('[data-v2-add-label]');
          //   const viewCartLabel = pdpButton.dataset.viewCartLabel;
          //   if (label && viewCartLabel) label.textContent = viewCartLabel;
          //   pdpButton.dataset.v2Added = 'true';
          //   pdpButton.classList.add('v2__submit--added');
          // }
        } catch (error) {
          form.submit();
        } finally {
          CartDrawer.busy(false);
        }
      });

      // Once the PDP button reads "View cart", clicking it should reopen the
      // drawer instead of re-submitting the form with a now-stale add click.
      document.addEventListener('click', (event) => {
        const button = event.target.closest('[data-v2-add][data-v2-added="true"]');
        if (!button) return;
        event.preventDefault();
        CartDrawer.open();
      });
    }
  }


  // Drag the grabber down to dismiss. Pointer events so a mouse works the
  // same as a finger; the grabber's own visibility decides where it applies.
  function enableSwipeClose(dialogSelector, onClose) {
    document.addEventListener('pointerdown', (event) => {
      const grabber = event.target.closest('[data-modal-grabber]');
      if (!grabber) return;

      const dialog = grabber.closest(dialogSelector);
      if (!dialog) return;

      event.preventDefault();
      const startY = event.clientY;
      let delta = 0;

      try {
        grabber.setPointerCapture(event.pointerId);
      } catch (error) {
        // Capture is a nicety; dragging still works without it.
      }

      const move = (moveEvent) => {
        delta = Math.max(0, moveEvent.clientY - startY);
        dialog.style.transition = 'none';
        dialog.style.transform = `translateY(${delta}px)`;
      };

      const end = () => {
        dialog.style.transition = '';
        dialog.style.transform = '';
        grabber.removeEventListener('pointermove', move);
        grabber.removeEventListener('pointerup', end);
        grabber.removeEventListener('pointercancel', end);
        if (delta > 80) onClose();
      };

      grabber.addEventListener('pointermove', move);
      grabber.addEventListener('pointerup', end);
      grabber.addEventListener('pointercancel', end);
    });
  }

  enableSwipeClose('[data-cart-drawer]', () => CartDrawer.close());

  // Info pills (PDP shipping/duties badges, mirrored in the cart drawer and
  // on the full cart page) — tap/click opens a small centered modal with
  // that pill's own title and full text, same on mobile and desktop. One
  // shared dialog (declared once, above the cart drawer's own) covers all
  // three pill locations: the trigger button just carries
  // data-badge-title/-text, read into the dialog when it opens.
  const badgeModal = document.querySelector('[data-badge-modal]');
  if (badgeModal) {
    const badgeModalTitle = badgeModal.querySelector('[data-badge-modal-title]');
    const badgeModalText = badgeModal.querySelector('[data-badge-modal-text]');

    // Triggers opt into the duties body with data-badge-body="duties"; every
    // other one still fills in the plain title/text from its own attributes.
    const badgeModalDuties = badgeModal.querySelector('[data-badge-modal-duties]');

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-badge-modal-open]');
      if (!trigger) return;

      const duties = trigger.dataset.badgeBody === 'duties';
      badgeModalDuties.hidden = !duties;
      badgeModalText.hidden = duties;

      badgeModalTitle.textContent = trigger.dataset.badgeTitle || '';
      if (!duties) badgeModalText.textContent = trigger.dataset.badgeText || '';

      badgeModal.showModal();
    });

    // Native <dialog> backdrop clicks land on the dialog itself.
    badgeModal.addEventListener('click', (event) => {
      if (event.target === badgeModal) badgeModal.close();
    });

    const badgeModalClose = badgeModal.querySelector('[data-badge-modal-close]');
    if (badgeModalClose) {
      badgeModalClose.addEventListener('click', () => badgeModal.close());
    }

    // Capture phase: scrolling inside the cart drawer's own scroll region
    // doesn't bubble a 'scroll' event to document, but it does fire there
    // during capture.
    document.addEventListener(
      'scroll',
      () => {
        if (badgeModal.open) badgeModal.close();
      },
      { passive: true, capture: true }
    );
  }

  window.CartDrawer = CartDrawer;
  CartDrawer.init();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // The link's href is a real fallback (no-JS, or before this runs); with
  // JS, open the account modal in place instead of navigating to it.
  document.querySelectorAll('[data-account-link]').forEach((link) => {
    const instance = link.parentElement.querySelector('[data-account-instance]');
    if (!instance) return;

    link.addEventListener('click', (event) => {
      event.preventDefault();
      instance.showModal();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // The menu drops out of the bar and lifts back into it. <details> hides its
  // own contents the instant `open` is removed, so the closing frame would
  // never render — the lift is played first and `open` dropped after it.
  document.querySelectorAll('.nav__disclosure').forEach((disclosure) => {
    const bar = disclosure.closest('.nav');
    const panel = disclosure.querySelector('.nav__panel');
    const summary = disclosure.querySelector('.nav__toggle');
    if (!bar || !panel || !summary) return;

    // The panel hangs off the bar, so its ceiling is whatever is left of the
    // viewport underneath. Scroll is locked while it is open, so the bar
    // cannot shift out from under it afterwards.
    const measure = () => {
      const room = window.innerHeight - bar.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--nav-panel-max', `${Math.max(0, room)}px`);
    };

    const closeMenu = () => {
      if (!disclosure.open) return;
      disclosure.classList.add('is-closing');

      const shut = () => {
        panel.removeEventListener('transitionend', onEnd);
        clearTimeout(timer);
        disclosure.classList.remove('is-closing');
        disclosure.open = false;
      };
      const onEnd = (e) => {
        if (e.propertyName !== 'translate') return;
        shut();
      };
      // A transition that never fires would otherwise strand the menu open.
      const timer = setTimeout(shut, 450);
      panel.addEventListener('transitionend', onEnd);
    };

    summary.addEventListener('click', (event) => {
      if (!disclosure.open) {
        measure();
        // Only one mobile menu open at a time — see the matching
        // dispatch/listener pair on the country selector below.
        document.dispatchEvent(new CustomEvent('mobile-menu-open', { detail: disclosure }));
        return;
      }

      event.preventDefault();
      closeMenu();
    });

    // The country selector announces its own opening the same way; close
    // this menu when it does. closeMenu() already no-ops if not open.
    document.addEventListener('mobile-menu-open', (event) => {
      if (event.detail !== disclosure) closeMenu();
    });

    // Tapping the page below the panel closes the menu, same as the cart
    // drawer's backdrop.
    const scrim = disclosure.querySelector('[data-nav-scrim]');
    if (scrim) {
      scrim.addEventListener('click', () => closeMenu());
    }

    // Drag the bar at the foot upward to dismiss, mirroring the drawer's
    // pull-down. Pointer events so a mouse behaves like a finger.
    const grabber = disclosure.querySelector('[data-nav-grabber]');
    if (grabber) {
      grabber.addEventListener('pointerdown', (event) => {
        if (!disclosure.open) return;
        event.preventDefault();

        const startY = event.clientY;
        let delta = 0;

        try {
          grabber.setPointerCapture(event.pointerId);
        } catch (error) {
          // Capture is a nicety; the drag still works without it.
        }

        // Inline `translate` only — the centring lives on `transform`, which
        // is a separate property, so the panel cannot lose its full-bleed
        // offset mid-drag.
        const move = (moveEvent) => {
          delta = Math.max(0, startY - moveEvent.clientY);
          panel.style.transition = 'none';
          panel.style.translate = `0 ${-delta}px`;
        };

        const end = () => {
          grabber.removeEventListener('pointermove', move);
          grabber.removeEventListener('pointerup', end);
          grabber.removeEventListener('pointercancel', end);
          panel.style.transition = '';

          if (delta > 80) {
            // Carries on upward from wherever the finger let go, rather than
            // snapping back to the closed offset first, and only actually
            // shuts once it is out of sight behind the bar.
            panel.style.translate = `0 -${Math.ceil(panel.getBoundingClientRect().height)}px`;
            summary.click();
            setTimeout(() => {
              panel.style.translate = '';
            }, 420);
            return;
          }

          // Short of the threshold, it springs back open.
          panel.style.translate = '';
        };

        grabber.addEventListener('pointermove', move);
        grabber.addEventListener('pointerup', end);
        grabber.addEventListener('pointercancel', end);
      });
    }

    window.addEventListener('resize', () => {
      if (disclosure.open) measure();
    });
    measure();
  });

  // Submit on change so the selector behaves like a control, not a form.
  // A <noscript> submit button covers the no-JS path.
  document.querySelectorAll('[data-locale-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const form = select.closest('form');
      if (form) form.submit();
    });
  });
  // ISO 3166 alpha-2 -> regional indicator pair. Done in JS rather than a
  // 79-row Liquid lookup table, and it stays correct if Markets change.
  function isoToFlag(iso) {
    if (!iso || iso.length !== 2) return '';
    return String.fromCodePoint(
      ...[...iso.toUpperCase()].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65)
    );
  }

  document.querySelectorAll('[data-locale-select]').forEach((select) => {
    const flag = select.closest('.locale__control')?.querySelector('[data-locale-flag]');

    const paint = () => {
      if (flag) flag.textContent = isoToFlag(select.value);
    };

    [...select.options].forEach((option) => {
      const emoji = isoToFlag(option.value);
      if (emoji && !option.textContent.startsWith(emoji)) {
        option.textContent = `${emoji}  ${option.textContent.trim()}`;
      }
    });

    paint();
    select.addEventListener('change', paint);
  });

  // Country dropdown: search box + pinned "Popular" group + full list, over
  // the native select above (which stays the real form field — clicking an
  // option here just sets its value and dispatches `change`, so the
  // submit-on-change and flag-repaint listeners above fire exactly as they
  // would for a native pick).
  document.querySelectorAll('[data-locale-root]').forEach((root) => {
    const select = root.querySelector('[data-locale-select]');
    const trigger = root.querySelector('[data-locale-trigger]');
    const panel = root.querySelector('[data-locale-panel]');
    // `trigger` never leaves the bar (only `panel` gets moved to <body>,
    // below), so this is always the real header bar.
    const nav = trigger.closest('.nav');
    if (!select || !trigger || !panel || !nav) return;

    const search = panel.querySelector('[data-locale-search]');
    const noResults = panel.querySelector('[data-locale-no-results]');
    const options = [...panel.querySelectorAll('[data-locale-option]')];
    if (!search || !options.length) return;

    options.forEach((option) => {
      const flagEl = option.querySelector('[data-option-flag]');
      if (flagEl) flagEl.textContent = isoToFlag(option.dataset.value);
    });

    // The clip is what makes the panel retract *behind* the bar on mobile
    // (see header.liquid's own .nav__panel-clip for the same reasoning) —
    // z-index alone can't do it, since the panel would still paint over
    // the bar while sliding past its edge. Fixed and spanning the full
    // viewport, appended to <body>: escapes both the mobile menu's own
    // overflow:hidden clip box and its transformed ancestor (a transform
    // creates a containing block for fixed-position descendants).
    const panelClip = document.createElement('div');
    panelClip.className = 'locale__panel-clip';
    document.body.appendChild(panelClip);
    panelClip.appendChild(panel);
    root.classList.add('locale--enhanced');

    // Only rendered/visible via CSS at desktop widths (the full-height
    // sidebar there) — .locale__scrim is display:none on mobile
    // regardless of its own hidden state, so creating and toggling it
    // unconditionally here is harmless on mobile too.
    const scrim = document.createElement('div');
    scrim.className = 'locale__scrim';
    scrim.hidden = true;
    scrim.setAttribute('aria-hidden', 'true');
    document.body.appendChild(scrim);

    const isOpen = () => !panel.hidden;

    const close = () => {
      if (panel.hidden) return;
      panel.hidden = true;
      scrim.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      nav.classList.remove('nav--locale-open');
    };

    // Only one mobile menu open at a time — the hamburger menu announces
    // its own opening the same way; close this one when it does.
    document.addEventListener('mobile-menu-open', (event) => {
      if (event.detail !== panel) close();
    });

    const place = () => {
      // Mobile: the same "drops from the bar" modal as the hamburger menu
      // (full width, hangs directly under the bar) instead of the small
      // anchored dropdown below — position the *clip*, not the panel
      // (which just fills it via CSS); that's what lets it retract
      // behind the bar. The scrim's top is pinned here too, same
      // reasoning as the hamburger's own clip box: the bar sits above it
      // and never dims, only the page below the panel does.
      if (window.innerWidth <= 699) {
        const navRect = nav.getBoundingClientRect();
        panelClip.style.top = `${navRect.bottom}px`;
        panelClip.style.setProperty('--locale-panel-max', `${Math.max(0, window.innerHeight - navRect.bottom)}px`);
        scrim.style.top = `${navRect.bottom}px`;
        return;
      }

      const gutter = 8;
      const triggerRect = trigger.getBoundingClientRect();
      const panelRect = panel.getBoundingClientRect();
      let left = triggerRect.right - panelRect.width;
      left = Math.max(gutter, Math.min(left, window.innerWidth - panelRect.width - gutter));
      let top = triggerRect.bottom + gutter;
      if (top + panelRect.height > window.innerHeight - gutter) {
        top = Math.max(gutter, triggerRect.top - panelRect.height - gutter);
      }
      panel.style.left = `${left}px`;
      panel.style.top = `${top}px`;
    };

    const filter = (term) => {
      const needle = term.trim().toLowerCase();
      let anyVisible = false;

      ['top', 'all'].forEach((groupName) => {
        const group = panel.querySelector(`[data-locale-group="${groupName}"]`);
        const label = panel.querySelector(`[data-locale-group-label="${groupName}"]`);
        if (!group) return;

        let groupHasVisible = false;
        [...group.querySelectorAll('[data-locale-option]')].forEach((option) => {
          // Name, currency code (data-code, e.g. "USD") and country code
          // (data-value, e.g. "US") all count — "us" should find "United
          // States" whether someone's thinking of the currency or the
          // country code, not just the printed name.
          const haystack = [option.dataset.name, option.dataset.code, option.dataset.value]
            .join(' ')
            .toLowerCase();
          const match = !needle || haystack.includes(needle);
          option.hidden = !match;
          if (match) groupHasVisible = true;
        });

        group.hidden = !groupHasVisible;
        if (label) label.hidden = !groupHasVisible;
        if (groupHasVisible) anyVisible = true;
      });

      if (noResults) noResults.hidden = anyVisible;
    };

    const open = () => {
      // At most one panel open at a time, across both instances on the page.
      document.querySelectorAll('[data-locale-panel]').forEach((p) => {
        if (p !== panel) p.hidden = true;
      });
      document.querySelectorAll('.locale__scrim').forEach((s) => {
        if (s !== scrim) s.hidden = true;
      });
      // Only one mobile menu open at a time — see the matching
      // dispatch/listener pair on the hamburger menu above.
      document.dispatchEvent(new CustomEvent('mobile-menu-open', { detail: panel }));
      panel.hidden = false;
      scrim.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');

      // Same flip the hamburger menu does on the homepage: the bar reverts
      // from inverted (white ink, transparent) to a normal filled white
      // bar with dark ink while this panel — a normal light sheet — is
      // open underneath it. Only at the width this modal treatment
      // actually applies; the small anchored dropdown below doesn't flip
      // anything, same as before.
      if (window.innerWidth <= 699) {
        nav.classList.add('nav--locale-open');
      }
      place();
      search.value = '';
      filter('');
      requestAnimationFrame(() => search.focus());
    };

    trigger.addEventListener('click', () => (isOpen() ? close() : open()));

    document.addEventListener('click', (event) => {
      if (!isOpen()) return;
      if (panel.contains(event.target) || trigger.contains(event.target)) return;
      close();
    });

    document.addEventListener('keydown', (event) => {
      if (!isOpen() || event.key !== 'Escape') return;
      close();
      trigger.focus();
    });

    // Closing on scroll rather than re-placing on every frame — simpler,
    // and avoids the panel drifting from a trigger that itself just
    // scrolled out of view. Scrolling the list itself (data-locale-list,
    // inside this same panel) must NOT count — that's the one scroll
    // gesture this control exists to let through, and closing on it made
    // the list impossible to swipe.
    window.addEventListener(
      'scroll',
      (event) => {
        if (!isOpen() || panel.contains(event.target)) return;
        close();
      },
      true
    );
    window.addEventListener('resize', () => isOpen() && close());

    search.addEventListener('input', () => filter(search.value));

    options.forEach((option) => {
      option.addEventListener('click', () => {
        select.value = option.dataset.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        close();
      });
    });

    // Mobile only: drag the grabber upward to dismiss, mirroring the
    // hamburger menu's own panel exactly (same threshold, same carry-
    // through-then-close so `hidden` — which, like <details>, hides its
    // content the instant it's set — doesn't cut the lift short).
    const grabber = panel.querySelector('[data-locale-grabber]');
    if (grabber) {
      grabber.addEventListener('pointerdown', (event) => {
        if (window.innerWidth > 699 || !isOpen()) return;
        event.preventDefault();

        const startY = event.clientY;
        let delta = 0;

        try {
          grabber.setPointerCapture(event.pointerId);
        } catch (error) {
          // Capture is a nicety; the drag still works without it.
        }

        const move = (moveEvent) => {
          delta = Math.max(0, startY - moveEvent.clientY);
          panel.style.transition = 'none';
          panel.style.translate = `0 ${-delta}px`;
        };

        const end = () => {
          grabber.removeEventListener('pointermove', move);
          grabber.removeEventListener('pointerup', end);
          grabber.removeEventListener('pointercancel', end);
          panel.style.transition = '';

          if (delta > 80) {
            panel.style.translate = `0 -${Math.ceil(panel.getBoundingClientRect().height)}px`;
            setTimeout(() => {
              close();
              panel.style.translate = '';
            }, 280);
            return;
          }

          panel.style.translate = '';
        };

        grabber.addEventListener('pointermove', move);
        grabber.addEventListener('pointerup', end);
        grabber.addEventListener('pointercancel', end);
      });
    }
  });

  // Live clock under the wordmark. Stated in the named city rather than the
  // visitor's own time — the label names a place, so it has to mean it.
  (function navClock() {
    const node = document.querySelector('[data-nav-clock]');
    if (!node) return;

    const zone = node.dataset.navTimezone || 'America/Vancouver';
    const place = node.dataset.navPlace || '';

    let parts;
    try {
      parts = new Intl.DateTimeFormat('en-US', {
        timeZone: zone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });
    } catch (error) {
      return; // Unknown zone: leave the server-rendered stamp alone.
    }

    let last = '';

    const tick = () => {
      const bits = {};
      parts.formatToParts(new Date()).forEach((part) => {
        bits[part.type] = part.value;
      });

      const stamp =
        bits.month + '/' + bits.day + '/' + bits.year + ' ' +
        bits.hour + ':' + bits.minute + (bits.dayPeriod || '').toLowerCase() +
        (place ? ' ' + place : '');

      if (stamp === last) return;
      last = stamp;
      node.textContent = stamp;
    };

    tick();
    setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail-v2"]) return;
  try {
    
  class ProductV2 {
    constructor(root) {
      this.root = root;
    }

    gallery() {
      const track = this.root.querySelector('[data-v2-track]');
      const thumbs = [...this.root.querySelectorAll('[data-v2-thumb]')];
      if (!track || !thumbs.length) return;

      const slides = [...track.querySelectorAll('[data-v2-slide]')];
      // instant is for the wrap from the last slide back to the first: the
      // track is scroll-behavior:smooth, so a smooth wrap rewinds visibly
      // through every image in between. A jump reads as "back to the start";
      // a rewind reads as a glitch.
      const goTo = (i, instant) => {
        const slide = slides[i];
        if (!slide) return;
        // 'instant', not 'auto' — 'auto' means "whatever CSS says", and CSS
        // here says smooth, so it animated the rewind anyway.
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: instant ? 'instant' : 'smooth' });
      };

      let current = 0;
      thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.v2Thumb))));

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              current = slides.indexOf(entry.target);
              thumbs.forEach((t, i) => t.setAttribute('aria-selected', String(i === current)));
            });
          },
          { root: track, threshold: 0.6 }
        );
        slides.forEach((s) => observer.observe(s));
      }

      const desktop = window.matchMedia('(min-width: 950px)');

      // A tap or click anywhere on the image advances one slide and wraps at
      // the end — the whole gallery is reachable without finding the thumbs
      // or knowing it can be swiped.
      //
      // Pointer events rather than click, because on touch the track is a
      // scroll-snap carousel and a swipe must not also count as a tap. Three
      // things disqualify a gesture: the finger moved, the track scrolled
      // under it, or it was held. The scroll check is the one that matters
      // most — a flick can travel almost no distance and still throw the
      // track to the next slide, and advancing again on top of that would
      // skip one.
      const TAP_SLOP = 10;
      const TAP_HOLD = 500;
      let tapStart = null;

      // Where a tap has sent the track, while it is still gliding there.
      // Taps are meant to be rapid-fire, and without this two things broke
      // when you tapped faster than the smooth scroll finishes:
      //
      //   - the scroll-delta guard below saw the track moving under the
      //     finger and threw the tap away as a swipe, so fast taps did
      //     nothing at all;
      //   - `current` comes from the IntersectionObserver, which only
      //     updates once a slide has settled, so the next tap computed its
      //     target from the slide you already left.
      //
      // Both are fixed by remembering our own target: it is the thing to
      // count from, and while it is set the track's movement is known to be
      // ours rather than a gesture. Cleared on scrollend (or a timer, for
      // browsers without it) once the track stops.
      let paging = null;
      let pagingTimer = 0;

      const clearPaging = () => {
        paging = null;
      };

      const page = (to) => {
        paging = to;
        goTo(to, to === 0);
        clearTimeout(pagingTimer);
        // Backstop only — scrollend clears this first wherever it exists.
        pagingTimer = setTimeout(clearPaging, 700);
      };

      track.addEventListener('scrollend', clearPaging, { passive: true });

      track.addEventListener(
        'pointerdown',
        (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) {
            tapStart = null;
            return;
          }
          tapStart = {
            x: event.clientX,
            y: event.clientY,
            at: Date.now(),
            left: track.scrollLeft,
            // Snapshotted here, not read at pointerup: by then this tap may
            // have already been answered.
            ours: paging !== null,
          };
        },
        { passive: true }
      );

      track.addEventListener('pointercancel', () => { tapStart = null; }, { passive: true });

      track.addEventListener(
        'pointerup',
        (event) => {
          const start = tapStart;
          tapStart = null;
          if (!start || slides.length < 2) return;
          // Video controls, links and buttons keep their own press.
          if (event.target.closest('video, iframe, a, button')) return;
          // A finger that travelled is a swipe, mid-page or not. This is the
          // guard that keeps swiping working exactly as it does now.
          if (Math.abs(event.clientX - start.x) > TAP_SLOP) return;
          if (Math.abs(event.clientY - start.y) > TAP_SLOP) return;
          // Only meaningful when the track was at rest: a flick can cover
          // almost no distance and still throw it a slide, and advancing on
          // top of that would skip one. When the movement is our own paging,
          // there is nothing to disambiguate.
          if (!start.ours && Math.abs(track.scrollLeft - start.left) > 2) return;
          if (Date.now() - start.at > TAP_HOLD) return;

          const from = paging === null ? current : paging;
          page((from + 1) % slides.length);
        },
        { passive: true }
      );

      // The gallery column is sticky on desktop, so it stays on screen while
      // the page scrolls past it. Hovering it redirects a vertical scroll
      // gesture into paging the gallery instead — down goes right, up goes
      // left — rather than letting the page keep scrolling underneath it.
      track.addEventListener(
        'wheel',
        (event) => {
          if (!desktop.matches) return;
          // Pinch-zoom on a trackpad also fires as a ctrl+wheel event —
          // leave that alone. A gesture that's already mostly horizontal
          // (a trackpad swipe) is left to scroll the track natively too.
          if (event.ctrlKey) return;
          if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;

          event.preventDefault();
          // Direct assignment, not scrollBy/scrollTo: the track has
          // scroll-behavior:smooth for click/thumb navigation, which would
          // otherwise queue a laggy animation on every wheel tick instead of
          // tracking the gesture 1:1.
          track.scrollLeft += event.deltaY;
        },
        { passive: false }
      );
    }

    // The bar is down whenever the buy box's own add-to-cart is on screen —
    // up to that point the real buy control is right there and a second,
    // smaller set of them is just noise — and up whenever it is not, whether
    // that is because you have not reached it yet or have scrolled past it.
    // Same on mobile as on desktop. Falls back to the top-of-page sentinel
    // when the add-to-cart is missing (a sold-out product has no form).
    // Views, reposts and sends are hidden until asked for. Hover does it on a
    // pointer device; on touch there is no hover, so the first tap on the
    // likes link opens the row instead of leaving for Instagram — the second
    // tap follows the link as normal.
    metrics() {
      const row = this.root.querySelector('[data-v2-metrics]');
      if (!row) return;

      const toggle = row.querySelector('[data-v2-metrics-toggle]');
      const link = row.querySelector('[data-v2-metrics-link]');

      const setOpen = (open) => {
        row.classList.toggle('is-open', open);
        if (toggle) toggle.setAttribute('aria-expanded', String(open));
      };

      if (toggle) {
        toggle.addEventListener('click', () => {
          setOpen(!row.classList.contains('is-open'));
        });
      }

      if (link) {
        link.addEventListener('click', (event) => {
          const touch = window.matchMedia('(hover: none)').matches;
          if (!touch) return;
          if (row.classList.contains('is-open')) return;
          event.preventDefault();
          setOpen(true);
        });
      }
    }

    // The comment wall arrives a couple of rows at a time. Cards past the
    // current batch are display:none, so the columns rebalance around what is
    // showing rather than leaving gaps where the hidden ones would have been.
    wall() {
      const wall = this.root.querySelector('[data-v2-wall]');
      const rows = this.root.querySelector('[data-v2-wall-rows]');
      const moreRow = this.root.querySelector('[data-v2-wall-more-row]');
      const more = this.root.querySelector('[data-v2-wall-more]');
      if (!wall || !rows || !moreRow || !more) return;

      // Full-width rows (the thank-you note) sit above the columns rather than
      // inside one of them; they used column-span, which real columns have no
      // equivalent for.
      const children = [...rows.children];
      const full = children.filter((el) => el.querySelector('.info-card'));
      const cards = children.filter((el) => !full.includes(el));

      const batch = Math.max(1, parseInt(wall.dataset.v2WallBatch, 10) || 6);
      if (cards.length <= batch) return;

      full.forEach((el) => el.classList.add('v2__wall-full'));

      // Real columns instead of CSS `columns`. A multi-column box rebalances
      // every card whenever its content changes, so revealing a batch moved
      // cards that were already on screen. These are only ever appended to.
      const colWrap = document.createElement('div');
      colWrap.className = 'v2__wall-cols';
      rows.appendChild(colWrap);
      rows.classList.add('is-columned');

      // Round-robin, not shortest-column-first: it keeps reading order across
      // the row, and it means a new batch lands at the foot of the wall
      // rather than filling out the end of the last column.
      const COL_MIN = 132;
      const COL_GAP = 8;
      let columnCount = 0;

      const measureColumns = () => {
        const width = rows.clientWidth || 1;
        return Math.max(1, Math.floor((width + COL_GAP) / (COL_MIN + COL_GAP)));
      };

      const distribute = (count) => {
        columnCount = count;
        colWrap.textContent = '';
        const cols = [];
        for (let i = 0; i < count; i += 1) {
          const col = document.createElement('div');
          col.className = 'v2__wall-col';
          colWrap.appendChild(col);
          cols.push(col);
        }
        cards.forEach((card, i) => cols[i % count].appendChild(card));
      };

      let shown = 0;

      const hideFrom = (index) => {
        cards.forEach((card, i) => {
          if (i >= index) {
            card.setAttribute('data-v2-wall-hidden', '');
          } else {
            card.removeAttribute('data-v2-wall-hidden');
          }
        });
      };

      distribute(measureColumns());

      // A width change can change the column count; that is a layout change,
      // not a reveal, so the cards are laid out again and the batch state is
      // reapplied by index.
      let resizeQueued = false;
      window.addEventListener('resize', () => {
        if (resizeQueued) return;
        resizeQueued = true;
        requestAnimationFrame(() => {
          resizeQueued = false;
          const next = measureColumns();
          if (next === columnCount) return;
          distribute(next);
          hideFrom(shown);
        });
      });

      // Delay by where the card ended up, not by its position in the markup:
      // a column layout fills top-to-bottom, so DOM order would animate as a
      // downward wipe. Sorting by row band then by x gives left-to-right,
      // then down, then left-to-right again.
      const stagger = (batchCards) => {
        const boxes = batchCards.map((card) => {
          const rect = card.getBoundingClientRect();
          return { card, top: rect.top, left: rect.left, height: rect.height };
        });

        // Cards in a column layout are appended to the foot of whichever
        // column is shortest, so two that read as level rarely share an exact
        // top. Banding by half a card's height groups the ones that look level
        // so they sweep left to right together; the bands themselves run down
        // the page.
        const heights = boxes.map((b) => b.height).sort((a, b) => a - b);
        const median = heights[Math.floor(heights.length / 2)] || 80;
        const band = Math.max(40, median * 0.5);

        const placed = boxes.sort((a, b) => {
          const row = Math.round(a.top / band) - Math.round(b.top / band);
          return row !== 0 ? row : a.left - b.left;
        });

        placed.forEach((entry, i) => {
          entry.card.style.setProperty('--v2-wall-delay', `${i * 45}ms`);
          entry.card.setAttribute('data-v2-wall-in', '');
        });

        // Let the animation finish, then drop the attributes so a later batch
        // does not re-run the first batch's animation.
        setTimeout(() => {
          placed.forEach((entry) => {
            entry.card.removeAttribute('data-v2-wall-in');
            entry.card.style.removeProperty('--v2-wall-delay');
          });
        }, 420 + placed.length * 45 + 60);
      };

      // Once everything is out the button turns into the way back, rather
      // than disappearing and stranding the reader at the foot of a very long
      // wall with nothing to act on.
      const moreLabelEl = more.querySelector('[data-v2-wall-more-label]');
      const labelMore = more.dataset.labelMore || (moreLabelEl ? moreLabelEl.textContent.trim() : more.textContent.trim());
      const labelLess = more.dataset.labelLess || labelMore;

      const atEnd = () => shown >= cards.length;

      const setLabel = () => {
        const isEnd = atEnd();
        if (moreLabelEl) {
          moreLabelEl.textContent = isEnd ? labelLess : labelMore;
        } else {
          more.textContent = isEnd ? labelLess : labelMore;
        }
        more.setAttribute('aria-expanded', String(isEnd));
      };

      const reveal = (animate) => {
        const next = cards.slice(shown, shown + batch);
        next.forEach((card) => card.removeAttribute('data-v2-wall-hidden'));
        shown += next.length;

        if (animate) stagger(next);
        setLabel();
      };

      const collapse = () => {
        const removed = cards.slice(batch);
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Collapsing removes a lot of height; without this the reader is left
        // wherever that height used to be, which is usually the footer. Fired
        // up front so the scroll and the fade read as one motion.
        const top = wall.getBoundingClientRect().top;
        if (top < 0) {
          wall.scrollIntoView({ block: 'start', behavior: reduced ? 'auto' : 'smooth' });
        }

        const finish = () => {
          hideFrom(batch);
          shown = batch;
          setLabel();
        };

        if (reduced || removed.length === 0) {
          finish();
          return;
        }

        // Mirrors the reveal-in stagger, in reverse: the last cards to arrive
        // are the first to leave, fading out in place instead of vanishing.
        const leaving = [...removed].reverse();
        leaving.forEach((card, i) => {
          card.style.setProperty('--v2-wall-delay', `${i * 30}ms`);
          card.setAttribute('data-v2-wall-out', '');
        });

        setTimeout(() => {
          leaving.forEach((card) => {
            card.removeAttribute('data-v2-wall-out');
            card.style.removeProperty('--v2-wall-delay');
          });
          finish();
        }, 280 + leaving.length * 30 + 60);
      };

      hideFrom(0);
      shown = 0;
      reveal(false);
      moreRow.hidden = false;

      more.addEventListener('click', () => {
        if (atEnd()) collapse();
        else reveal(true);
      });
    }

    stickyBar() {
      const bar = this.root.querySelector('[data-v2-sticky]');
      if (!bar) return;

      // Was the wallet button; that is gone, so the add-to-cart button is the
      // thing whose passing means the buy controls have left the screen.
      const wallet = this.root.querySelector('.v2__form [data-v2-add]');
      const early = bar.hasAttribute('data-v2-sticky-early');
      const sentinel = this.root.querySelector('[data-v2-top]');
      const target = wallet || sentinel;

      if (!target || !('IntersectionObserver' in window)) {
        bar.classList.add('is-visible');
        return;
      }

      if (!wallet) {
        const observer = new IntersectionObserver(
          ([entry]) => bar.classList.toggle('is-visible', !entry.isIntersecting),
          { rootMargin: '-72px 0px 0px 0px' }
        );
        observer.observe(sentinel);
        return;
      }

      // Measured rather than observed: Shopify renders the wallet button
      // itself, so until its script lands the element has no height, and a
      // zero-area target never crosses an IntersectionObserver threshold —
      // the bar would simply never appear. Reading the rect works whatever
      // state the button is in.
      let queued = false;
      const check = () => {
        queued = false;
        const rect = wallet.getBoundingClientRect();
        // The bar is the stand-in for this button, so it shows when the
        // button is not usefully in view — still below the fold, or risen
        // near enough to the top that it is on its way out. While the button
        // sits properly in view the bar stays down rather than putting a
        // second, smaller add-to-cart over the top of the real one.
        //
        // The reveal line is why this is a fraction of the viewport rather
        // than the button simply having left the screen. With every toggle
        // closed — the default — the mobile PDP is only about two and a bit
        // viewports tall, so at the very bottom of the page the buy box is
        // still sitting near the top of the screen and never scrolls off at
        // all. Waiting for it to leave meant the bar was never up when you
        // reached the end of the page, which is exactly where a buy control
        // is wanted. Crossing the line a fifth of the way down brings it back
        // about a hundred pixels before the document ends.
        //
        // A fraction, not a pixel count, because the taller the viewport the
        // lower the buy box ends up sitting when the page bottoms out — a
        // fixed threshold would clear it on this phone and miss on a bigger
        // one. (It was `rect.top < 0` before that, which assumed a page tall
        // enough to scroll the button off the top; with the wall collapsed
        // there is no such page, and the bar never appeared at all.)
        // Never while the button is on screen at all — on every product,
        // the Banackpack included. Not "nearly gone", not "near the end of
        // the page": on screen is on screen. Two add-to-carts in view at
        // once is the thing to avoid, and because these pages are short the
        // buy box is still sitting up there when you reach the footer, so
        // every looser test ended up putting the bar over the footer art.
        const past = rect.bottom <= 0;

        // Before the buy box has been reached, only the Banackpack shows one
        // (see data-v2-sticky-early in the markup). Its page is several times
        // longer than the rest of the catalogue's, so the buy box is a long
        // way down and a bar that waits leaves most of the scroll with no buy
        // control at all. Every other product's page is about a viewport and
        // a half, where showing it early only covers a button you are about
        // to reach anyway.
        const notYet = rect.top >= window.innerHeight;

        bar.classList.toggle('is-visible', past || (early && notYet));
      };
      const onScroll = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(check);
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      // The button grows when Shopify swaps the skeleton for the real thing.
      if ('ResizeObserver' in window) new ResizeObserver(onScroll).observe(wallet);
      check();
    }

    // Keep the page's bottom padding equal to the bar's real height so the
    // footer always clears it, whatever the bar happens to contain.
    reserveStickySpace() {
      const bar = this.root.querySelector('[data-v2-sticky]');
      if (!bar) return;

      const apply = () => {
        const height = Math.ceil(bar.getBoundingClientRect().height);
        if (height > 0) {
          document.documentElement.style.setProperty('--v2-sticky-space', `${height + 4}px`);
        }
      };

      apply();

      if ('ResizeObserver' in window) {
        new ResizeObserver(apply).observe(bar);
      } else {
        window.addEventListener('resize', apply);
      }
    }

    // Two steppers — buy box and sticky bar — kept in lockstep so the number
    // the shopper sees is always the number that gets added.
    quantity() {
      const groups = [...this.root.querySelectorAll('[data-v2-qty]')];
      if (!groups.length) return;

      const apply = (value) => {
        groups.forEach((wrap) => {
          const input = wrap.querySelector('[data-v2-input]');
          const down = wrap.querySelector('[data-v2-down]');
          if (!input || !down) return;
          input.value = String(value);
          down.disabled = value <= 1;
        });
      };

      const clean = (raw) => {
        const value = parseInt(raw, 10);
        return Number.isFinite(value) && value > 0 ? value : 1;
      };

      groups.forEach((wrap) => {
        const input = wrap.querySelector('[data-v2-input]');
        const down = wrap.querySelector('[data-v2-down]');
        const up = wrap.querySelector('[data-v2-up]');
        if (!input || !down || !up) return;

        down.addEventListener('click', () => apply(Math.max(1, clean(input.value) - 1)));
        up.addEventListener('click', () => apply(clean(input.value) + 1));
        input.addEventListener('input', () => apply(clean(input.value)));
      });

      apply(clean(groups[0].querySelector('[data-v2-input]').value));
    }

    // Two pickers — buy box and sticky bar — kept in lockstep, the same way
    // the quantity steppers and the add-on checkboxes are. A radio group
    // cannot span two forms, so these are separate groups and a pick in one
    // has to be mirrored into the other; otherwise the sticky bar posts
    // whatever variant the page was rendered with. Every price node follows.
    variants() {
      const radios = [...this.root.querySelectorAll('input[name="id"][data-variant-price]')];
      if (!radios.length) return;

      const prices = [...this.root.querySelectorAll('[data-v2-price]')];

      radios.forEach((radio) => {
        radio.addEventListener('change', () => {
          if (!radio.checked) return;

          // Assigning `checked` fires no change event, so this cannot loop.
          radios.forEach((other) => {
            if (other !== radio && other.value === radio.value) other.checked = true;
          });

          prices.forEach((node) => {
            node.textContent = radio.dataset.variantPrice;
          });
        });
      });
    }

    // Features & details, Comments, the pre-order strip and the shipping
    // strip are all <details> — animate their open/close instead of the
    // browser's instant show/hide. Height is measured rather than assumed,
    // so this works regardless of how much content each one holds.
    accordions() {
      const items = this.root.querySelectorAll('.v2__fold, .v2__preorder, .info-card');

      items.forEach((details) => {
        const summary = details.querySelector(':scope > summary');
        if (!summary || details.dataset.v2Animated) return;
        details.dataset.v2Animated = 'true';

        let animation = null;
        let isClosing = false;
        let isExpanding = false;

        summary.addEventListener('click', (event) => {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          event.preventDefault();
          details.style.overflow = 'hidden';

          if (isClosing || !details.open) {
            openDetails();
          } else if (isExpanding || details.open) {
            shrink();
          }
        });

        function openDetails() {
          details.style.height = `${details.offsetHeight}px`;
          details.open = true;
          window.requestAnimationFrame(() => expand());
        }

        function expand() {
          isExpanding = true;
          const startHeight = `${details.offsetHeight}px`;
          const previousHeight = details.style.height;
          details.style.height = 'auto';
          const endHeight = `${details.offsetHeight}px`;
          details.style.height = previousHeight;

          if (animation) animation.cancel();
          animation = details.animate(
            { height: [startHeight, endHeight] },
            { duration: 220, easing: 'ease-out' }
          );
          animation.onfinish = () => onAnimationFinish(true);
          animation.oncancel = () => { isExpanding = false; };
        }

        function shrink() {
          isClosing = true;
          const startHeight = `${details.offsetHeight}px`;
          const endHeight = `${summary.offsetHeight}px`;

          if (animation) animation.cancel();
          animation = details.animate(
            { height: [startHeight, endHeight] },
            { duration: 220, easing: 'ease-out' }
          );
          animation.onfinish = () => onAnimationFinish(false);
          animation.oncancel = () => { isClosing = false; };
        }

        function onAnimationFinish(isOpen) {
          details.open = isOpen;
          animation = null;
          isClosing = false;
          isExpanding = false;
          details.style.height = '';
          details.style.overflow = '';
        }
      });
    }

    // Mobile only (2026-09-15): the features fold moves above the price
    // instead of sitting below it — desktop keeps the original position
    // (its own stylesheet rule scopes the toggle removal to mobile too,
    // so there's nothing to reorder around there). A comment node marks
    // the fold's natural spot so crossing back over the breakpoint
    // (resize, rotation) restores it exactly rather than leaving it
    // wherever the mobile move put it.
    featuresPosition() {
      const fold = this.root.querySelector('[data-v2-fold-features]');
      const form = this.root.querySelector('.v2__form');
      if (!fold || !form) return;

      const anchor = document.createComment('v2-features-fold-anchor');
      fold.after(anchor);

      const mq = window.matchMedia('(max-width: 749px)');
      const place = (isMobile) => {
        if (isMobile) {
          form.before(fold);
        } else {
          anchor.after(fold);
        }
      };

      place(mq.matches);
      mq.addEventListener('change', (event) => place(event.matches));
    }

    // Pre-order and shipping (compact, closed by default) move above
    // Comments and its thank-you note, so Comments sits last in the group
    // with the note under it.
    //
    // At every width as of 2026-09-18. It was mobile-only when written —
    // Comments was a big permanently-open wall then, and the point was to
    // stop the two quick-reference toggles being stranded below all of it,
    // which only mattered on a phone. Comments is a closed toggle now and
    // the ordering argument is the plain one: the terms toggles are what a
    // buyer checks before ordering, the wall is what they browse afterwards,
    // and that is true on a desktop too. So the media query, the anchor
    // comment it restored source order against, and the change listener all
    // go — there is only one arrangement left to produce.
    //
    // Whichever fold ends up leading the group also gets .v2__fold--lead,
    // which is what carries the "clear of the buttons above" margin in the
    // stylesheet. Still assigned rather than hardcoded: which fold leads
    // depends on whether this product has a pre-order notice at all.
    // Safari starts the reel and then stops it — in testing it played 2.75s,
    // paused itself, and scrolling it back into view did not restart it, while
    // Chromium ran straight through. autoplay/muted/playsinline are all already
    // on the element, so this is the browser's own policy rather than a missing
    // attribute: it has to be asked again, at the moments it is willing to say
    // yes.
    //
    // Only ever asked while the reel is actually on screen. Safari pausing
    // offscreen video is deliberate battery behaviour and worth leaving alone —
    // fighting it would keep a video decoding behind the fold for no one.
    reelAutoplay() {
      const reel = this.root.querySelector('video.v2__reel-media');
      if (!reel) return;

      // Properties, not just the attributes already in the markup: WebKit
      // reads the live property when deciding whether a play() without a
      // user gesture is allowed.
      reel.muted = true;
      reel.playsInline = true;

      let inView = true;
      const nudge = () => {
        if (!inView || !reel.paused) return;
        const attempt = reel.play();
        // A refused play() rejects; swallow it rather than letting it surface
        // as an unhandled rejection on every retry.
        if (attempt && attempt.catch) attempt.catch(() => {});
      };

      // The moments a browser will reconsider: more data arrived, the tab came
      // back, or it paused itself.
      ['loadeddata', 'canplay', 'stalled', 'pause'].forEach((evt) => {
        reel.addEventListener(evt, nudge);
      });
      document.addEventListener('visibilitychange', nudge);

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              inView = entry.isIntersecting;
              if (inView) nudge();
            });
          },
          { threshold: 0.1 }
        ).observe(reel);
      }

      // The first gesture anywhere on the page lifts the restriction outright,
      // so take one shot on each and then stop listening.
      ['touchstart', 'pointerdown', 'scroll'].forEach((evt) => {
        window.addEventListener(evt, nudge, { once: true, passive: true });
      });

      nudge();
    }

    reorderClosedFolds() {
      const comments = this.root.querySelector('.v2__comments');
      if (!comments) return; // Non-hero products have no Comments to reorder around.

      const preorder = this.root.querySelector('[data-v2-fold-preorder]');
      const shipping = this.root.querySelector('[data-v2-fold-shipping]');
      const movers = [preorder, shipping].filter(Boolean);
      if (!movers.length) return;

      comments.before(...movers);

      this.root.querySelectorAll('.v2__fold--lead').forEach((el) => {
        el.classList.remove('v2__fold--lead');
      });
      movers[0].classList.add('v2__fold--lead');
    }

    // "View cart" only stands in for "Add to cart" until the shopper changes
    // their mind about what they are adding — a new quantity or variant means
    // the button's promise (this exact line is in the cart) no longer holds.
    resetAddedOnChange() {
      const buttons = [...this.root.querySelectorAll('[data-v2-add]')];
      if (!buttons.length) return;

      this.root.addEventListener('change', () => {
        buttons.forEach((button) => {
          if (button.dataset.v2Added !== 'true') return;
          button.dataset.v2Added = 'false';
          button.classList.remove('v2__submit--added');
          const label = button.querySelector('[data-v2-add-label]');
          if (label) label.textContent = button.dataset.addLabel;
        });
      });
    }

    // The wallet button checks out a single variant and never touches the
    // cart, so it cannot carry the pin. When the pin is ticked we intercept,
    // put both lines in the cart, and send the shopper to checkout instead.
    acceleratedCheckout() {
      const wraps = [...this.root.querySelectorAll('.shopify-payment-button')];
      const boxes = [...this.root.querySelectorAll('[data-addon-variant]')];
      if (!wraps.length || !boxes.length) return;

      wraps.forEach((wrap) => wrap.addEventListener(
        'click',
        async (event) => {
          const addon = boxes.find((box) => box.checked);
          if (!addon) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          const form = this.root.querySelector('.v2__form');
          const root =
            (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const data = new FormData(form);

          try {
            const response = await fetch(`${root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [
                  { id: Number(data.get('id')), quantity: Number(data.get('quantity')) || 1 },
                  { id: Number(addon.dataset.addonVariant), quantity: 1 },
                ],
              }),
            });
            // Sold out or inventory-capped: send them to the cart, where the
            // real state is visible. Returning here left the wallet button
            // doing nothing at all.
            if (!response.ok) {
              window.location.href = `${root}cart`;
              return;
            }
            window.location.href = `${root}checkout`;
          } catch (error) {
            window.location.href = `${root}cart`;
          }
        },
        true
      ));
    }

    // Add-on posts a second line item in the same submit. Both checkboxes
    // (buy box and sticky bar) mirror each other.
    addon() {
      const boxes = [...this.root.querySelectorAll('[data-addon-variant]')];
      const forms = [...this.root.querySelectorAll('.v2__form, .v2-sticky__form')];
      if (!boxes.length || !forms.length) return;

      boxes.forEach((box) => {
        box.addEventListener('change', () => {
          boxes.forEach((other) => {
            if (other !== box) other.checked = box.checked;
          });
        });
      });

      const addon = boxes[0];

      forms.forEach((form) => form.addEventListener(
        'submit',
        async (event) => {
          if (!addon.checked) return;
          event.preventDefault();
          event.stopImmediatePropagation();

          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const data = new FormData(form);
          const items = [
            { id: Number(data.get('id')), quantity: Number(data.get('quantity')) || 1 },
            { id: Number(addon.dataset.addonVariant), quantity: 1 },
          ];

          try {
            const response = await fetch(`${root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items }),
            });
            if (!response.ok) {
              form.submit();
              return;
            }
            if (window.CartDrawer) {
              await window.CartDrawer.refresh();
              window.CartDrawer.open();
            }
          } catch (error) {
            form.submit();
          }
        },
        true
      ));
    }

    init() {
      this.gallery();
      this.wall();
      this.metrics();
      this.stickyBar();
      this.reserveStickySpace();
      this.quantity();
      this.variants();
      this.addon();
      this.accordions();
      this.featuresPosition();
      this.reorderClosedFolds();
      this.reelAutoplay();
      this.resetAddedOnChange();
      this.acceleratedCheckout();
    }
  }

  document.querySelectorAll('.v2').forEach((el) => new ProductV2(el).init());

  // <summary> only covers the collapsed row, so an open card can be closed
  // from its heading but not from the text below it. This makes the whole
  // card a toggle, leaving anything genuinely interactive inside it alone.
  document.addEventListener('click', (event) => {
    const body = event.target.closest('.info-card__body, .v2__fold-body');
    if (!body) return;
    if (event.target.closest('a, button, input, label, summary')) return;

    const card = body.closest('details');
    if (!card || !card.open) return;

    const summary = card.querySelector(':scope > summary');
    if (summary) {
      summary.click();
    } else {
      card.open = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !Shopify.designMode) return;
  try {
    
  // Viewer-local clock. The server-rendered value stays as the no-JS fallback.
  class ShowcaseClock {
    constructor(el) {
      this.el = el;
      this.format = new Intl.DateTimeFormat(undefined, {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      });
    }

    tick() {
      const now = new Date();
      this.el.textContent = this.format.format(now);
      this.el.setAttribute('datetime', now.toISOString());
    }

    start() {
      this.tick();
      // Align to the top of the next minute, then tick once a minute.
      const msToNextMinute = 60000 - (Date.now() % 60000);
      setTimeout(() => {
        this.tick();
        setInterval(() => this.tick(), 60000);
      }, msToNextMinute);
    }
  }

  document.querySelectorAll('[data-clock]').forEach((el) => {
    new ShowcaseClock(el).start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-v3"]) return;
  try {
    
  (function productV3() {
    const root = document.querySelector('.v3-pdp');
    if (!root) return;

    const main = root.querySelector('[data-v3-main]');
    const select = root.querySelector('[data-v3-select]');
    const colour = root.querySelector('[data-v3-colour]');
    const prices = [...root.querySelectorAll('[data-v3-price]')];
    const thumbs = [...root.querySelectorAll('[data-v3-thumb]')];

    // Swapping the main picture has to clear srcset as well as src, or the
    // browser keeps serving a candidate from the old set.
    const show = (src, alt) => {
      if (!main || !src) return;
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = src;
      if (alt) main.alt = alt;
    };

    const markActive = (thumb) => {
      thumbs.forEach((other) => {
        const on = other === thumb;
        other.classList.toggle('is-active', on);
        other.setAttribute('aria-pressed', String(on));
      });
    };

    const syncFromSelect = () => {
      if (!select) return;
      const option = select.selectedOptions[0];
      if (!option) return;
      prices.forEach((node) => {
        node.textContent = option.dataset.v3VariantPrice;
      });
      if (colour && colour.dataset.v3Colour === 'variant') {
        colour.textContent = option.dataset.v3VariantTitle || colour.textContent;
      }
      const match = thumbs.find((t) => t.dataset.v3Variant === option.value);
      if (match) {
        markActive(match);
        show(match.dataset.v3Src, match.dataset.v3Alt);
      }
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        markActive(thumb);
        show(thumb.dataset.v3Src, thumb.dataset.v3Alt);

        // Colour cells move the selection too; gallery cells only swap the
        // picture, so the posted variant is untouched.
        const id = thumb.dataset.v3Variant;
        if (id && select) {
          select.value = id;
          syncFromSelect();
        }
      });
    });

    if (select) select.addEventListener('change', syncFromSelect);
  })();

  } catch(e) { console.error(e); }
})();
})();
